var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.543,
    height: 16.101,
    viewBox: "0 0 15.543 16.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cut",
    transform: "translate(-1405 -252.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503",
    transform: "translate(1405 253.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1011",
    "data-name": "Ellipse 1011",
    fill: "none",
    stroke: "#353e44",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.859,
    cy: 2.859,
    r: 2.859,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.859,
    cy: 2.859,
    r: 2.259,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M.1,1.177s10.091-.022,10.966.01S13.989-.01,12.741,0,2.978.1,0,.1",
    transform: "translate(5.191 4.409) rotate(45)",
    fill: "#353e44",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6504",
    "data-name": "Group 6504",
    transform: "translate(1405.001 253.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1011-2",
    "data-name": "Ellipse 1011",
    transform: "translate(0 9.256)",
    fill: "none",
    stroke: "#353e44",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.859,
    cy: 2.859,
    r: 2.859,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.859,
    cy: 2.859,
    r: 2.259,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507-2",
    "data-name": "Path 11507",
    d: "M.1,0,3,.005l.13,1.182H0",
    transform: "translate(4.192 9.835) rotate(-45)",
    fill: "#353e44",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11508",
    "data-name": "Path 11508",
    d: "M0,0C3.016,0,4.016.072,4.978.042S8.2,1.2,6.822,1.187c-.907-.006-4.275-.025-6.712-.046C.043,1.16.147,1.1.043,1.1.04,1.1,0,0,0,0",
    transform: "translate(8.716 5.47) rotate(-45)",
    fill: "#353e44",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.9e9ee5ce474306dd31982935f2eb8a55.svg";
export { ForwardRef as ReactComponent };